<evsb-standard-modal-window [fullHeight]="true">
  <header>
    <evsb-modal-header>
      {{ "modules.evcSmallBiz.mailOfferForm.modalTitle" | translate }}
    </evsb-modal-header>
  </header>
  <section modal-content class="flex overflow-y-auto">
    <evsb-mail-offer-form></evsb-mail-offer-form>
  </section>
  <footer>
    <evsb-modal-footer>
      <div class="w-full flex flex-col gap-5">
        <evsb-primary-button [fullWidth]="true" (click)="submitData()">
          {{ "modules.evcSmallBiz.mailOfferForm.submit" | translate }}
        </evsb-primary-button>
      </div>
    </evsb-modal-footer>
  </footer>
</evsb-standard-modal-window>
